var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import RenderIf from 'syf-component-library/ui/atoms/RenderIf';
import Banner from './Banner';
import { PlanDetails, SettlementDetails } from './Detail';
import PlanMessageBox from './MessageBox';
import useTriggerAnalyticsEvent from '../../../helpers/triggerAnalyticsEvent';
import { Routes } from '../../../const';
var Success = function (_a) {
    var _b;
    var settlement = _a.settlement, plan = _a.plan, navigateTo = _a.navigateTo, autoPayStatus = _a.autoPayStatus, isModalReady = _a.isModalReady;
    var planName = (_b = settlement === null || settlement === void 0 ? void 0 : settlement.plan) === null || _b === void 0 ? void 0 : _b.planName;
    var pageAnalytics = settlement
        ? 'settlementPlanSuccess'
        : 'capPlanSuccess';
    var currentRoute = settlement
        ? Routes.SETTLEMENT_SUCCESS
        : Routes.PLAN_SUCCESS;
    useTriggerAnalyticsEvent({
        featureEvent: pageAnalytics,
        questionId: planName,
        currentRoute: currentRoute,
        reEnrollAutoPay: !!autoPayStatus,
        shouldTrigger: isModalReady
    });
    var currentFlow = settlement ? 'settlement' : 'plan';
    return (_jsxs(_Fragment, { children: [_jsx(RenderIf, __assign({ condition: Boolean(plan && autoPayStatus) }, { children: _jsx(PlanMessageBox, { navigateTo: navigateTo, autoPayStatus: autoPayStatus, currentRoute: currentRoute }) })), _jsx(Banner, { currentFlow: currentFlow }), _jsx(RenderIf, __assign({ condition: Boolean(settlement) }, { children: _jsx(SettlementDetails, { settlement: settlement }) })), _jsx(RenderIf, __assign({ condition: Boolean(plan) }, { children: _jsx(PlanDetails, { plan: plan }) }))] }));
};
export default Success;
//# sourceMappingURL=index.js.map